export class HrApplicantStatus {
    id!: string
    candidateName!: string
    position!: string
    drugTest = false
    referenceCheck = false
    voes = false
    sourceOfApplication!: string
}
